const getToken = () => localStorage.getItem("token");

// Функція для відправки запитів
async function request(url, options = {}) {
  // Формуємо хедери
  const headers = { "Content-Type": "application/json", ...options.headers };

  // Додаємо токен, якщо він є
  const token = getToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  // Формуємо повний URL з параметрами запиту (для GET)
  const fetchOptions = { ...options };
  let finalUrl = `/api${url}`;

  if (fetchOptions.params) {
    const params = fetchOptions.params;
    const queryParts = [];

    // Сереалізуємо об'єкт в URL
    for (const key in params) {
      const value = params[key];

      if (Array.isArray(value)) {
        // Обробляємо масиви
        value.forEach((item) => {
          queryParts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
        });
      } else if (value !== null && value !== undefined && value !== "") {
        // Обробляємо звичайні значення
        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
      }
    }

    if (queryParts.length > 0) {
      finalUrl += `?${queryParts.join("&")}`;
    }

    // Видаляємо `params` з опцій, які підуть у fetch
    delete fetchOptions.params;
  }

  try {
    const response = await fetch(finalUrl, {
      ...fetchOptions,
      headers,
    });

    // Обробка відповіді без тіла (напр., DELETE)
    if (response.status === 204) {
      return true;
    }

    if (options.responseType === "blob") {
      // Якщо помилка обробляємо як json тіло з помилкою
      if (!response.ok) {
        try {
          const errorData = await response.json();
          const error = new Error(
            errorData.error || errorData.message || `Помилка: ${response.status}`,
          );
          error.response = response;
          throw error;
        } catch (e) {
          const error = new Error(`Помилка: ${response.status}`);
          error.response = response;
          throw error;
        }
      }
      // Якщо все ОК, повертаємо blob
      return response.blob();
    }

    const data = await response.json();
    // Обробка помилок
    if (!response.ok) {
      const error = new Error(
        data.error || data.message || `Помилка: ${response.status}`,
      );
      error.response = response;
      throw error;
    }

    return data;
  } catch (err) {
    console.error("API Service Error:", err);
    throw err;
  }
}

export const api = {
  get: (url, params, config = {}) => request(url, { params, method: "GET", ...config }),
  post: (url, body, config = {}) =>
    request(url, { body: JSON.stringify(body), method: "POST", ...config }),
  put: (url, body, config = {}) =>
    request(url, { body: JSON.stringify(body), method: "PUT", ...config }),
  patch: (url, body, config = {}) =>
    request(url, { body: JSON.stringify(body), method: "PATCH", ...config }),
  delete: (url, config = {}) => request(url, { method: "DELETE", ...config }),
};
